// extracted by mini-css-extract-plugin
export default {"editorRoot":"Editor_editorRoot__7j2BO"};